module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "admin-filter"
    }
  }, [_c('h4', [_vm._v("GST-VAT Filter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.originLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectLocation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "service"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.service),
      expression: "entity.service"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "service"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.serviceTypes), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.code
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.emitSearch
    }
  }, [_vm._v("\n      Search\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0914ff33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/QuoteTax/QuoteTaxFilter.vue
// module id = 2083
// module chunks = 1